import AircraftInfo from './AircraftInfo';
export default AircraftInfo;
